import { Button, Stack } from '@mui/material';
import { sendOTP } from 'api/auth';
import RedirectProvider from 'components/RedirectProvider';
import Timer from 'components/Timer';
import { AuthContext, SnackBarContext } from 'constants/contexts';
import useIsMobile from 'hooks/useIsMobile';
import useSentryUpdateEffect from 'hooks/useSentryUpdateEffect';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useHistory } from 'react-router';
import http from 'services/http';
import { captureException, getHttpErrorMessage } from 'utils/error';
import { SessionJsonStorage } from 'utils/storage';
import AuthWrapper from './AuthWrapper';

function OTP() {
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const { user, setUser } = useContext(AuthContext);
  const showSnackBar = useContext(SnackBarContext);
  const history = useHistory();
  const { redirect } = RedirectProvider.useRedirect();
  const isMobile = useIsMobile();

  useSentryUpdateEffect({
    page: 'otp',
  }, []);

  const goToLogin = () => {
    history.replace('/login');
  };

  const onSubmit = useCallback(() => {
    setLoading(true);
    sendOTP({
      code,
      token: user.token,
    })
      .then(() => {

        http.get('user/profile/', { headers: { Authorization: user.token } }).then(res => {
          const userData = res.data.message;
          if (userData.name && userData.email) {
            setUser({
              tokenVerified: true,
              ...userData,
            });
            redirect();
          } else {
            setUser({
              tokenVerified: true,
            });
            history.replace('/signup');
          }
          setLoading(false);

          SessionJsonStorage.set({
            key: 'quoted-order',
            value: null,
          });

        }).catch((e) => {
          captureException(e);
          showSnackBar({ message: getHttpErrorMessage(e), type: 'error' });
          setLoading(false);
        });

      })
      .catch((e) => {
        captureException(e);
        showSnackBar({ message: getHttpErrorMessage(e), type: 'error' });
        setLoading(false);
      });
  }, [code, user.token]);

  useEffect(() => {
    if (code?.length === 5) {
      onSubmit();
    }
  }, [code, onSubmit]);

  return (
    <AuthWrapper
      subTitle={`Please enter OTP code for ${user?.phone}`}
      action={(
        <Stack sx={{ gap: 2, justifyContent: 'space-between', flexDirection: { xs: "row", md: "column"} }}>
          <Button size={isMobile ? 'medium' : 'large'} fullWidth disabled={loading} onClick={goToLogin}>
            Wrong number?
          </Button>
          <Button
            size={isMobile ? 'medium' : 'large'}
            fullWidth
            variant="muted"
            disabled={!isFinished || loading}
            onClick={goToLogin}
          >
            {isFinished ? 'Resend code' : (
              <>
                <span>Resend code{!isMobile && ' via SMS ('}</span>
                <Timer
                  minutes={2}
                  isFinished={isFinished}
                  setIsFinished={setIsFinished}
                  hidden={isMobile}
                />
                {!isMobile && <span>)</span>}
              </>
            )}

          </Button>
        </Stack>
      )}
    >
      <Stack sx={{
        width: '100%',
        '& .otp-input': {
          display: 'flex !important',
          justifyContent: 'space-between',
        },
      }}>
        <ReactCodeInput
          value={code}
          onChange={(otp) => setCode(otp)}
          type="tel"
          fields={5}
          className="otp-input"
          disabled={loading}
          inputStyle={{
            width: 48,
            height: 48,
            borderRadius: 12,
            border: '1px solid #E0E0E0',
            fontSize: 16,
            boxSizing: 'border-box',
            color: 'black',
            textAlign: 'center',
          }}

        />
      </Stack>
    </AuthWrapper>
  );
}

export default OTP;
